import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile-about',
  templateUrl: './user-profile-about.component.html',
  styleUrls: ['./user-profile-about.component.css']
})
export class UserProfileAboutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
